"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSmartTracking = function SvgIconSmartTracking(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "smart tracking icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Smart Tracking Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.5 6a7.509 7.509 0 017.5 7.5c0 4.564-6.154 10.953-6.904 11.714l-.065.066a.75.75 0 01-.999.056l-.063-.056C33.685 24.993 27 18.255 27 13.5A7.509 7.509 0 0134.5 6zm0 4.875a2.625 2.625 0 00-.131 5.247l.131.003a2.626 2.626 0 000-5.25zm-3.843 14.148c.771.88 1.404 1.532 1.722 1.85.137.134.288.255.45.358a.38.38 0 01.171.315v6.204a3 3 0 01-3 3h-8.25a.75.75 0 00-.75.75v.75c0 .414.336.75.75.75h3.75a1.5 1.5 0 010 3h-12a1.5 1.5 0 010-3h3.75a.75.75 0 00.75-.75v-.75a.75.75 0 00-.75-.75H9a3 3 0 01-3-3V18a3 3 0 013-3h15.6a.375.375 0 01.37.3c.168.746.402 1.476.7 2.181a.374.374 0 01-.346.519H9.75a.75.75 0 00-.75.75V31.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75v-6.231c0-.156.097-.296.243-.351a.372.372 0 01.414.105z"
  }));
};

var _default = SvgIconSmartTracking;
exports.default = _default;